import instance from "./request";


//新增一体机
export const addInpect = (data) => instance.post('/inspect/add', data)
//修改一体机
export const editInpect = (data) => instance.post('/inspect/edit', data)
//一体机详情
export const inpectInfo = (id) => instance.get('/inspect/info/' + id)



//新增体验设备
export const addExperience = (data) => instance.post('/experience/add', data)
//修改体验设备
export const editExperience = (data) => instance.post('/experience/edit', data)
//体验设备详情
export const experienceInfo = (id) => instance.get('/experience/info/' + id)